import { ReactElement } from 'react';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';
import { FormContextValues } from '@dreryk/react-common';

import { translationKeys } from '../translations';
import { WaitlistForm } from '../form/WaitlistForm';
import { WaitlistFormLoader } from '../form/WaitlistForm.loader';

import { WaitlistEntryCreateModalConfirmButton } from './WaitlistEntryCreateModalConfirmButton';
import { WaitlistEntryCreateFormBean } from './WaitlistEntryCreate.types';
import { getInitialValues } from './WaitlistEntryCreate.utils';

type WaitlistEntryModalProps = {
   onClose: VoidFunction;
};

export const WaitlistEntryCreateModal = (props: WaitlistEntryModalProps): ReactElement => {
   return (
      <Modal testId={'waitlistEntry'} title={translationKeys.addEntryToTheWaitlist} width={ModalWidth.WIDE}>
         <WaitlistFormLoader>
            {({ practitioners, currentPractitioner }) => (
               <WaitlistForm
                  initialValues={getInitialValues(practitioners?.at(0) ?? currentPractitioner)}
                  currentPractitioner={currentPractitioner}
                  practitioners={practitioners}
               >
                  {({ handleSubmit, formState }) => (
                     <>
                        <WaitlistEntryCreateModalConfirmButton
                           handleSubmit={handleSubmit as FormContextValues<WaitlistEntryCreateFormBean>['handleSubmit']}
                           onSuccess={props.onClose}
                        />
                        <ModalCancelButton
                           onClick={props.onClose}
                           shouldConfirmExit={{
                              enabled: formState.isDirty,
                              confirmationButtonLabel: translationKeys.leave,
                           }}
                        />
                        <ModalCloseButton
                           onClick={props.onClose}
                           shouldConfirmExit={{
                              enabled: formState.isDirty,
                              confirmationButtonLabel: translationKeys.leave,
                           }}
                        />
                     </>
                  )}
               </WaitlistForm>
            )}
         </WaitlistFormLoader>
      </Modal>
   );
};
